import React, {useEffect, useState} from 'react';
import {WdiGridApp} from '@/components/WdiBus/PanelForWarning';
import {FormSa} from '@/services/sales/sa';
import {wdiCore} from '@/components/GridWidget';
import {Enum} from '@/enums/system';
import {Empty} from "antd";

const FormBudgetInfo: Record<string, any> = {
  bgId: (_: any, record: any) => {
    return record['bgName'];
  },
  productLineId: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productLineCode'], record['productLineName']);
  },
  ecId: (_: any, record: any) => {
    if (record['budgetControlType'] == Enum.BudGetControlType.SPECIAL) {
      return <span style={{color: "#ff0000"}}>{record['ecName']}</span>;
    } else {
      return <span>{record['ecName']}</span>;
    }
  },
  ym: (_: any, record: any) => {
    return record['ym'];
  },
  amount: (_: any, record: any) => {
    return wdiCore.Number.ToNumber(record['amount'], 2);
  },
  revenueMtd: (value: any, record: any) => {
    if (record['revenueMtd'] == null || record['revenueMtd'] == 0) {
      return <span style={{color: '#ff0000'}}>{record['revenueMtd']}</span>;
    }

    return wdiCore.Number.ToNumber(value, 2);
  },
  expenseMtd: (value: any, record: any) => {
    return wdiCore.Number.ToNumber(value, 2);
  },
  rateActualMtd: (_: any, record: any) => {
    let isError: boolean = false;
    let hasStandard: boolean = true;

    if (record['revenueMtd'] == null || record['revenueMtd'] == 0) {
      isError = true;
    }

    if (record['rateBaselineMtd'] == null) {
      hasStandard = false;
    }

    if (record['budgetControlType'] == Enum.BudGetControlType.CONTROL) {
      let isRed: boolean = false;
      if (record['revenueMtd'] == null || record['revenueMtd'] == 0
        || record['rateBaselineMtd'] == null || record['rateActualMtd'] > record['rateBaselineMtd']) {
        isRed = true;
      }

      return <>
        <span
          style={isRed ? {color: "#ff0000"} : {}}>{!isError ? wdiCore.Number.RateToString(record['rateActualMtd']) : "error"}</span>
        <span>({hasStandard ? wdiCore.Number.RateToString(record['rateBaselineMtd']) : "未设置"})</span>
      </>;
    } else if (record['budgetControlType'] == Enum.BudGetControlType.SPECIAL) {
      return <span
        style={isError ? {color: "#ff0000"} : {}}>{!isError ? wdiCore.Number.RateToString(record['rateActualMtd']) : "error"}</span>;
    }

    return "";
  },
  rateActualMtdLy: (value: any, record: any) => {
    return wdiCore.Number.RateToString(value);
  },
  rateMaxMtd: (value: any, record: any) => {
    return wdiCore.Number.RateToString(value);
  },
  revenueYtd: (value: any, record: any) => {
    if (record['revenueYtd'] == null || record['revenueYtd'] == 0) {
      return <span style={{color: '#ff0000'}}>{record['revenueYtd']}</span>;
    }

    return wdiCore.Number.ToNumber(value, 2);
  },
  expenseYtd: (value: any, record: any) => {
    return wdiCore.Number.ToNumber(value, 2);
  },
  rateActualYtd: (_: any, record: any) => {
    let isError: boolean = false;
    let hasStandard: boolean = true;

    if (record['revenueYtd'] == null || record['revenueYtd'] == 0) {
      isError = true;
    }

    if (record['rateBaselineYtd'] == null) {
      hasStandard = false;
    }

    if (record['budgetControlType'] == Enum.BudGetControlType.CONTROL) {
      let isRed: boolean = false;
      if (record['revenueYtd'] == null || record['revenueYtd'] == 0
        || record['rateBaselineYtd'] == null || record['rateActualYtd'] > record['rateBaselineYtd']) {
        isRed = true;
      }

      return <>
        <span
          style={isRed ? {color: "#ff0000"} : {}}>{!isError ? wdiCore.Number.RateToString(record['rateActualYtd']) : "error"}</span>
        <span>({hasStandard ? wdiCore.Number.RateToString(record['rateBaselineYtd']) : "未设置"})</span>
      </>;
    } else if (record['budgetControlType'] == Enum.BudGetControlType.SPECIAL) {
      return <span
        style={isError ? {color: "#ff0000"} : {}}>{!isError ? wdiCore.Number.RateToString(record['rateActualYtd']) : "error"}</span>;
    }

    return "";
  },
  rateActualYtdLy: (value: any, record: any) => {
    return wdiCore.Number.RateToString(value);
  },
  rateMaxYtd: (value: any, record: any) => {
    return wdiCore.Number.RateToString(value);
  },
  rateActualYtdTotal: (value: any, record: any) => {
    return wdiCore.Number.RateToString(value);
  },
  rateActualYtdLyTotal: (value: any, record: any) => {
    return wdiCore.Number.RateToString(value);
  },
  rowNumbers: (_: any, record: any) => {
    return record['rowNumbers'];
  },
};

const FormBudgetInfoEc: Record<string, any> = {
  bgId: (_: any, record: any) => {
    return record['bgName'];
  },
  productLineId: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productLineCode'], record['productLineName']);
  },
  ecId: (_: any, record: any) => {
    return record['ecName'];
  },
  ym: (_: any, record: any) => {
    return record['ym'];
  },
  amount: (_: any, record: any) => {
    return wdiCore.Number.ToNumber(record['amount'], 2);
  },
  revenueMtd: (value: any, record: any) => {
    if (record['revenueMtd'] == null || record['revenueMtd'] == 0) {
      return <span style={{color: '#ff0000'}}>{record['revenueMtd']}</span>;
    }

    return wdiCore.Number.ToNumber(value, 2);
  },
  expenseMtd: (value: any, record: any) => {
    return wdiCore.Number.ToNumber(value, 2);
  },
  rateActualMtd: (_: any, record: any) => {
    let isError: boolean = false;
    let hasStandard: boolean = true;

    if (record['revenueMtd'] == null || record['revenueMtd'] == 0) {
      isError = true;
    }

    if (record['rateBaselineMtd'] == null) {
      hasStandard = false;
    }

    let isRed: boolean = false;
    if (record['revenueMtd'] == null || record['revenueMtd'] == 0
      || record['rateBaselineMtd'] == null || record['rateActualMtd'] > record['rateBaselineMtd']) {
      isRed = true;
    }

    return <>
      <span
        style={isRed ? {color: "#ff0000"} : {}}>{!isError ? wdiCore.Number.RateToString(record['rateActualMtd']) : "error"}</span>
      <span>({hasStandard ? wdiCore.Number.RateToString(record['rateBaselineMtd']) : "未设置"})</span>
    </>;
  },
  rateActualMtdLy: (value: any, record: any) => {
    return wdiCore.Number.RateToString(value);
  },
  rowNumbers: (_: any, record: any) => {
    return record['rowNumbers'];
  },
};

const BudgetInformation: React.FC<{ formId?: number }> = (props) => {
  const [budgetInfos, setBudgetInfos] = useState<API.WdiPanelList>();
  const [budgetCount, setBudgetCount] = useState<number>(-1);

  useEffect(() => {
    if (props.formId) {
      FormSa.Buttons.budgetInfos(props.formId).then((response) => {
        setBudgetInfos(response.data);
        if (response.data && response.data.items) {
          setBudgetCount(response.data.items.length);
        } else {
          setBudgetCount(0);
        }
      });
    }
  }, [props.formId]);

  const renderWdiGridApp = (grid: API.WdiGrid) => {
    const columns: any[] = [];
    grid.wdiColumns.map((wdiColumn) => {
      if (!wdiColumn.isHidden) {
        const column = {
          title: wdiColumn.displayName,
          dataIndex: wdiColumn.name,
          width: wdiColumn.width,
          ellipsis: true,
          render: (grid.key == "SaBudgetImportant" || grid.key == "SaBudgetImportSubmit") ? FormBudgetInfoEc[wdiColumn.name] : FormBudgetInfo[wdiColumn.name]
        };
        columns.push(column);
      }
    });

    return (
      <WdiGridApp
        key={grid.key}
        wdiGrid={grid}
        columns={columns}
        dataSource={grid.items}
        isExport={false}
        exportColumns={[]}
      />
    );
  };
  return (
    <>
      {budgetInfos?.items?.map((item) => {
        return (
          renderWdiGridApp(item)
        );
      })}
      {budgetCount === 0 &&
        <div>
          <div style={{marginTop: "200px", textAlign: "center"}}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="没有预算信息"/>
          </div>
        </div>
      }
    </>
  );
};

export default BudgetInformation;
